import React from 'react';
import { ArticleHeading3, InformationTooltip, UIText2, ArticleHeading4 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { PskTooltipContent } from './components/PskTooltipContent';
import { transformNumToString } from 'shared/utils/common';
import { PERCENT } from 'shared/constants/common';
import styles from './styles.css';
import { IPsk } from 'shared/types/common/offer';
import { useIsDesktop } from '../../../../hooks/common';

export interface IPskBlockProps extends IPsk {}

export const PskBlock: React.FC<IPskBlockProps> = ({ from, to }) => {
  const isDesktop = useIsDesktop();
  const rangeText = transformNumToString(+from) + '—' + transformNumToString(+to) + PERCENT;

  return (
    <div role="button" onClick={e => e.stopPropagation()} className={styles['container']}>
      <InformationTooltip
        placement={'right-start'}
        content={<PskTooltipContent />}
        header={'Полная стоимость кредита'}
        portal={true}
      >
        <div>
          <div className={styles['title']}>
            <UIText2 color={'current_color'}>Полная стоимость кредита</UIText2>
            <div className={styles['tooltip']}>
              <IconFunctionalInformationCircle16 color={'icon-secondary-default'} cursor="pointer" />
            </div>
          </div>
          <div className={styles['description']}>
            {isDesktop ? (
              <ArticleHeading4 color={'current_color'}>{rangeText}</ArticleHeading4>
            ) : (
              <ArticleHeading3 color={'current_color'}>{rangeText}</ArticleHeading3>
            )}
          </div>
        </div>
      </InformationTooltip>
    </div>
  );
};
